"use strict";

var _slicedToArray = require("/codebuild/output/src305412778/src/github.com/rteamweb/web-marketing-ui/application/node_modules/@babel/runtime/helpers/slicedToArray.js");

var _taggedTemplateLiteral = require("/codebuild/output/src305412778/src/github.com/rteamweb/web-marketing-ui/application/node_modules/@babel/runtime/helpers/taggedTemplateLiteral.js");

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7, _templateObject8;

var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  var desc = Object.getOwnPropertyDescriptor(m, k);

  if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
    desc = {
      enumerable: true,
      get: function get() {
        return m[k];
      }
    };
  }

  Object.defineProperty(o, k2, desc);
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});

var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  }

  __setModuleDefault(result, mod);

  return result;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var jsx_runtime_1 = require("@emotion/react/jsx-runtime");

var react_1 = __importStar(require("react"));

var styled_1 = __importDefault(require("@emotion/styled"));

var frontend_layout_1 = require("@ryerson/frontend.layout");

var frontend_typography_1 = require("@ryerson/frontend.typography");

var frontend_form_controls_1 = require("@ryerson/frontend.form-controls");

var frontend_button_1 = require("@ryerson/frontend.button");

var react_2 = require("@emotion/react");

var frontend_theme_1 = require("@ryerson/frontend.theme");

var SearchResultItemContent_1 = require("./SearchResultItemContent");

var ItemLink_1 = require("../common/ItemLink");

var frontend_quantity_uom_inputs_1 = require("@ryerson/frontend.quantity-uom-inputs");

var frontend_common_1 = require("@ryerson/frontend.common");

var common_permissions_1 = require("@ryerson/common.permissions");

var frontend_application_1 = require("@ryerson/frontend.application");

var frontend_common_2 = require("@ryerson/frontend.common");

var frontend_e_commerce_1 = require("@ryerson/frontend.e-commerce");

var DeliveryTimesRequestMapper_1 = require("../Header/Helpers/DeliveryTimesRequestMapper");

var axios_1 = __importDefault(require("axios"));

var frontend_common_3 = require("@ryerson/frontend.common");

var ResultItemWrapper = (0, styled_1.default)(frontend_layout_1.Flex)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n\tborder-bottom: 1px solid rgba(82, 92, 107, 0.1);\n\tpadding-bottom: 20px;\n\t&:not(:last-child) {\n\t\tmargin-bottom: 20px;\n\t}\n"])));
var PricingMeasureDropdown = (0, styled_1.default)(frontend_form_controls_1.Dropdown)(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n\tfont-size: 14px;\n\ttext-transform: lowercase;\n"])));
var imageContainerWrapperStyles = (0, react_2.css)(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n\tmargin-right: 15px;\n"])));
var dropdownInputStyles = (0, react_2.css)(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n\twidth: 70px;\n"])));
var buttonWrapperStyles = (0, react_2.css)(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n\tmargin-top: 10px;\n"])));
var ImageContainer = styled_1.default.img(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["\n\theight: 50px;\n\twidth: 50px;\n\tobject-fit: contain;\n\tbackground: ", ";\n\t", ";\n"])), function (props) {
  return props.theme.colors.primary.white;
}, function (props) {
  var bgColor = props.bgColor,
      breakpoint = props.breakpoint;
  return (0, react_2.css)(_templateObject7 || (_templateObject7 = _taggedTemplateLiteral(["\n\t\t\tbackground: ", ";\n\t\t\t@media only screen and (max-width: ", ") {\n\t\t\t\theight: 60px;\n\t\t\t\twidth: 60px;\n\t\t\t}\n\t\t"])), bgColor, breakpoint);
});

var SearchResultItemDesktop = function SearchResultItemDesktop(_ref) {
  var item = _ref.item,
      storeDirectory = _ref.storeDirectory,
      deliveryTimes = _ref.deliveryTimes,
      setDeliveryTimes = _ref.setDeliveryTimes,
      stateMessenger = _ref.stateMessenger,
      setSearchText = _ref.setSearchText,
      setTriggerDeliveryTimes = _ref.setTriggerDeliveryTimes;

  var _ref2 = (0, frontend_theme_1.useTheme)(),
      theme = _ref2.theme;

  var _ref3 = (0, frontend_application_1.useApplication)(),
      hasPermission = _ref3.hasPermission,
      language = _ref3.localization.language,
      profile = _ref3.profile,
      axiosInstance = _ref3.axiosInstance,
      isLoggedIn = _ref3.user.isLoggedIn,
      zipCode = _ref3.zipCode;

  var _ref4 = (0, frontend_e_commerce_1.useEcommerce)(),
      addToCart = _ref4.addToCart,
      customerPickup = _ref4.customerPickup,
      defaultShipToAddress = _ref4.defaultShipToAddress,
      selectedShipToAddress = _ref4.selectedShipToAddress,
      salesPlant = _ref4.salesPlant,
      setSearchAddedToCart = _ref4.setSearchAddedToCart;

  var _ref5 = (0, react_1.useState)(0),
      _ref6 = _slicedToArray(_ref5, 2),
      quantity = _ref6[0],
      setQuantity = _ref6[1]; // Create Default UOM options for quantity and pricing


  var _ref7 = (0, frontend_common_2.getUsersDefaultUomValue)(item, profile),
      defaultQtyUom = _ref7.defaultQtyUom,
      defaultPricingUom = _ref7.defaultPricingUom,
      qtyUomOption = _ref7.qtyUomOption,
      pricingUomOption = _ref7.pricingUomOption;

  var _ref8 = (0, react_1.useState)(defaultQtyUom),
      _ref9 = _slicedToArray(_ref8, 2),
      quantityMeasure = _ref9[0],
      setQuantityMeasure = _ref9[1];

  var _ref10 = (0, react_1.useState)(defaultPricingUom),
      _ref11 = _slicedToArray(_ref10, 2),
      pricingMeasure = _ref11[0],
      setPricingMeasure = _ref11[1];

  var _react_1$default$useS = react_1.default.useState(false),
      _react_1$default$useS2 = _slicedToArray(_react_1$default$useS, 2),
      hasMounted = _react_1$default$useS2[0],
      setHasMounted = _react_1$default$useS2[1];

  var _react_1$default$useS3 = react_1.default.useState({}),
      _react_1$default$useS4 = _slicedToArray(_react_1$default$useS3, 2),
      queryParams = _react_1$default$useS4[0],
      setQueryParams = _react_1$default$useS4[1];

  var _react_1$default$useS5 = react_1.default.useState(""),
      _react_1$default$useS6 = _slicedToArray(_react_1$default$useS5, 2),
      queryString = _react_1$default$useS6[0],
      setQueryString = _react_1$default$useS6[1];

  var _ref12 = (0, frontend_application_1.useNotifications)(),
      addNotification = _ref12.addNotification;
  /*pubsub messaging*/


  var _react_1$default$useS7 = react_1.default.useState([]),
      _react_1$default$useS8 = _slicedToArray(_react_1$default$useS7, 2),
      message = _react_1$default$useS8[0],
      setMessage = _react_1$default$useS8[1];

  var _react_1$default$useS9 = react_1.default.useState(false),
      _react_1$default$useS10 = _slicedToArray(_react_1$default$useS9, 2),
      isDebouncing = _react_1$default$useS10[0],
      setIsDebouncing = _react_1$default$useS10[1];

  var _react_1$default$useS11 = react_1.default.useState(false),
      _react_1$default$useS12 = _slicedToArray(_react_1$default$useS11, 2),
      hasError = _react_1$default$useS12[0],
      setHasError = _react_1$default$useS12[1];

  var addDefaultSrc = function addDefaultSrc(event) {
    if (!event.target.src.includes("/NoImageImage.svg")) {
      event.target.src = "/NoImageImage.svg";
    }
  };

  var _react_1$default$useS13 = react_1.default.useState([]),
      _react_1$default$useS14 = _slicedToArray(_react_1$default$useS13, 2),
      deliveryTimesForSingleItem = _react_1$default$useS14[0],
      setDeliveryTimesForSingleItem = _react_1$default$useS14[1];

  var _react_1$default$useS15 = react_1.default.useState(),
      _react_1$default$useS16 = _slicedToArray(_react_1$default$useS15, 2),
      leadTimeDays = _react_1$default$useS16[0],
      setLeadTimeDays = _react_1$default$useS16[1];

  var getCorrectCase = function getCorrectCase(word) {
    return word ? word.charAt(0).toUpperCase() + word.slice(1).toLowerCase() : "";
  };

  var canCartViewEdit = function canCartViewEdit() {
    return hasPermission(common_permissions_1.Permission.Cart_View_Edit);
  };
  /** @desc -Listener for Pub Sub Messages from other components 	*/

  /* Note: the use of publishing messages (pubsub) to receive messages from quantityUOm Component
          if value is true  of "is-debouncing" then we are currently debouncing
  */


  react_1.default.useEffect(function () {
    var _message = _slicedToArray(message, 2),
        messageString = _message[0],
        value = _message[1];

    if (messageString === "is-debouncing") {
      setIsDebouncing(value);
    }
  }, [message]);
  react_1.default.useEffect(function () {
    if (hasMounted) {
      // Subscribe to pub-sub  stateMessenger
      stateMessenger === null || stateMessenger === void 0 ? void 0 : stateMessenger.subscribe(function (msg, value, topic) {
        return setMessage([msg, value, topic]);
      });
    }
  }, [hasMounted]);
  react_1.default.useEffect(function () {
    setHasMounted(true);
    return function () {
      setMessage([]);
      stateMessenger === null || stateMessenger === void 0 ? void 0 : stateMessenger.subscribe(function () {
        return undefined;
      })();
    };
  }, []);
  react_1.default.useEffect(function () {
    var _a;

    if (deliveryTimes.length) {
      setLeadTimeDays((_a = findProductLeadTime(deliveryTimes)) === null || _a === void 0 ? void 0 : _a.leadTimeDays);
    }
  }, [deliveryTimes]);
  react_1.default.useEffect(function () {
    var _a;

    if (deliveryTimesForSingleItem.length) {
      setLeadTimeDays((_a = findProductLeadTime(deliveryTimesForSingleItem)) === null || _a === void 0 ? void 0 : _a.leadTimeDays);
    }
  }, [deliveryTimesForSingleItem]);

  var onClickAddToCart = function onClickAddToCart() {
    var itemToAdd = {
      ryersonSku: item.materialMaster,
      quantity: Number(quantity),
      quantityUom: quantityMeasure,
      pricingUom: pricingMeasure,
      customerRefNumber: null,
      domesticRequired: false,
      notes: null,
      purchaseOrderNumber: null,
      customerPartNumber: (0, frontend_common_2.getCustomerPartNumber)((item === null || item === void 0 ? void 0 : item.altPartNumber) || ""),
      category: item.category,
      form: item.form
    };
    addToCart(axiosInstance, isLoggedIn, [itemToAdd], handleOnSuccessAddToCart);
  };

  var handleOnSuccessAddToCart = function handleOnSuccessAddToCart(response) {
    setSearchAddedToCart(true); // set flag to warn cart to update

    if (!isLoggedIn || (response === null || response === void 0 ? void 0 : response.data)) {
      sendAddToCartNotification(item);
    }

    setDeliveryTimesForSingleItem([]);
    setDeliveryTimes([]);
    setTriggerDeliveryTimes(true);
  };

  var getLeadTime = function getLeadTime(deliveryTimes) {
    var _a;

    var leadTimes = deliveryTimes.find(function (times) {
      return times.materialSku === item.materialMaster;
    });
    return (leadTimes === null || leadTimes === void 0 ? void 0 : leadTimes.leadTimeDays) && ((_a = (0, frontend_common_1.getMaxLeadTimeDay)(leadTimes === null || leadTimes === void 0 ? void 0 : leadTimes.leadTimeDays)) === null || _a === void 0 ? void 0 : _a.totalLeadTime);
  };

  var findProductLeadTime = function findProductLeadTime(deliveryTimes) {
    return deliveryTimes.find(function (times) {
      return times.materialSku === item.materialMaster;
    });
  };

  var sendAddToCartNotification = function sendAddToCartNotification(item) {
    if (item) {
      var mappedItem = Object.assign(Object.assign({}, item), {
        comboKey: item.comboKey || "",
        quantity: quantity,
        quantityUOM: quantityMeasure,
        priceUOM: pricingMeasure,
        leadTime: getLeadTime(deliveryTimesForSingleItem || deliveryTimes),
        form: item === null || item === void 0 ? void 0 : item.form,
        leadTimeDisplay: (0, frontend_common_1.getLeadTimeRangeDisplay)(leadTimeDays, language)
      });
      var messageId = new Date().getTime();
      var notification = (0, jsx_runtime_1.jsx)(frontend_application_1.AddToCartNotification, {
        products: [mappedItem],
        messageId: messageId,
        storeDirectory: storeDirectory
      });
      var _message2 = {
        id: messageId,
        timeOut: 5000,
        type: "add-to-cart",
        message: notification
      };
      addNotification(_message2);
    }
  };

  var generateProductUrl = (0, react_1.useMemo)(function () {
    var formattedQueryString = queryString ? "?".concat(queryString) : "";
    return "".concat(item === null || item === void 0 ? void 0 : item.id).concat(formattedQueryString);
  }, [queryString]);
  react_1.default.useEffect(function () {
    setQueryString(Object.keys(queryParams).map(function (key) {
      return "".concat(encodeURIComponent(key), "=").concat(encodeURIComponent(queryParams[key]));
    }).join("&"));
  }, [JSON.stringify(queryParams)]);

  var onPricingMeasureChange = function onPricingMeasureChange(value) {
    setPricingMeasure(value);
    setQueryParams(Object.assign(Object.assign({}, queryParams), {
      priceUom: value
    }));
  };

  var onQuantityUpdate = function onQuantityUpdate(quantity, uom) {
    if (quantity) {
      setQuantity(quantity);
      setQuantityMeasure(uom);
      setQueryParams(Object.assign(Object.assign({}, queryParams), {
        quantity: Number(quantity),
        quantityUom: uom
      }));
    }
  }; //Use Typed a value to debounce


  react_1.default.useEffect(function () {
    var unmounted = false;
    var cTokenSource = axios_1.default.CancelToken.source();
    var cTokenObject = {
      cancelToken: cTokenSource.token
    };

    if (quantity) {
      setLeadTimeDays(undefined);
      setTriggerDeliveryTimes(false);
      var itemsAvailabilityRequest = (0, DeliveryTimesRequestMapper_1.createItemsAvailabilityRequest)([item], isLoggedIn, selectedShipToAddress ? selectedShipToAddress : defaultShipToAddress, defaultShipToAddress, customerPickup, salesPlant, zipCode, {
        materialSku: item.materialMaster,
        quantity: Number(quantity),
        quantityUom: quantityMeasure,
        pricingUom: pricingMeasure,
        itemNumber: 1
      }, profile); //Success Callback

      var handleSuccess = function handleSuccess(response) {
        var responseData = response === null || response === void 0 ? void 0 : response.data;

        if (responseData) {
          !unmounted && setDeliveryTimesForSingleItem(responseData);
        } else {
          !unmounted && setDeliveryTimesForSingleItem([]);
        }
      }; //Error Callback


      var handleError = function handleError() {};

      (0, frontend_common_3.getDeliveryTimes)(itemsAvailabilityRequest, axiosInstance, handleSuccess, handleError, cTokenObject);
    }

    return function () {
      //cleanup
      unmounted = true;
      cTokenSource.cancel("Cancelling in cleanup");
    };
  }, [quantity, quantityMeasure, pricingMeasure]);
  return (0, jsx_runtime_1.jsxs)(ResultItemWrapper, {
    justifyContent: "space-between",
    children: [(0, jsx_runtime_1.jsx)(frontend_layout_1.FlexItem, {
      style: imageContainerWrapperStyles,
      children: (0, jsx_runtime_1.jsx)(ImageContainer, {
        theme: theme,
        onError: function onError(event) {
          return addDefaultSrc(event);
        },
        src: "/static-assets/images/renderings/".concat(getCorrectCase(item === null || item === void 0 ? void 0 : item.category)).concat(getCorrectCase(item === null || item === void 0 ? void 0 : item.form)).concat((item === null || item === void 0 ? void 0 : item.shape) !== "N/A" ? getCorrectCase(item === null || item === void 0 ? void 0 : item.shape) : "", ".png")
      })
    }), (0, jsx_runtime_1.jsxs)(frontend_layout_1.Flex, {
      direction: "column",
      gutter: 2,
      children: [(0, jsx_runtime_1.jsxs)(frontend_typography_1.Typography, {
        size: "xs",
        children: [item === null || item === void 0 ? void 0 : item.category, " ", item === null || item === void 0 ? void 0 : item.form]
      }), (0, ItemLink_1.getItemLink)(item, generateProductUrl, storeDirectory, setSearchText), (0, jsx_runtime_1.jsx)(frontend_typography_1.Typography, {
        size: "sm",
        children: item === null || item === void 0 ? void 0 : item.description
      }), (0, jsx_runtime_1.jsxs)(frontend_typography_1.Typography, {
        size: "xs",
        children: ["Lead Time: ", (0, frontend_common_1.getLeadTimeRangeDisplay)(leadTimeDays, language)]
      })]
    }), (0, jsx_runtime_1.jsxs)(frontend_layout_1.FlexItem, {
      style: (0, react_2.css)(_templateObject8 || (_templateObject8 = _taggedTemplateLiteral(["\n\t\t\t\t\twidth: 160px;\n\t\t\t\t"]))),
      children: [(0, jsx_runtime_1.jsxs)(frontend_layout_1.Flex, {
        justifyContent: "flex-end",
        alignItems: "flex-start",
        gutter: 2,
        children: [(0, jsx_runtime_1.jsx)(frontend_layout_1.FlexItem, {
          children: (0, jsx_runtime_1.jsx)(frontend_typography_1.Typography, {
            size: "sm",
            children: "Qty:"
          })
        }), (0, jsx_runtime_1.jsx)(frontend_quantity_uom_inputs_1.QuantityUOM, {
          quantityUomOptions: qtyUomOption,
          id: item.id,
          itemData: item,
          size: "sm",
          type: "primary",
          disabled: false,
          isSubmitted: true,
          quantityValue: Number(quantity),
          uomValue: quantityMeasure,
          handleValidationResponse: function handleValidationResponse(hasError) {
            return setHasError(hasError);
          },
          handleChange: onQuantityUpdate,
          stateMessenger: stateMessenger
        })]
      }), (0, jsx_runtime_1.jsxs)(frontend_layout_1.Flex, {
        justifyContent: "flex-end",
        alignItems: "center",
        gutter: 2,
        children: [(0, jsx_runtime_1.jsx)(frontend_typography_1.Typography, {
          size: "sm",
          children: "Price (UOM):"
        }), (0, jsx_runtime_1.jsx)(frontend_layout_1.FlexItem, {
          style: dropdownInputStyles,
          children: (0, jsx_runtime_1.jsx)(PricingMeasureDropdown, {
            size: "sm",
            onChange: onPricingMeasureChange,
            options: pricingUomOption,
            value: pricingMeasure,
            language: language
          })
        })]
      }), canCartViewEdit() && (0, jsx_runtime_1.jsx)(frontend_layout_1.Flex, {
        justifyContent: "flex-end",
        direction: "column",
        style: buttonWrapperStyles,
        children: (0, jsx_runtime_1.jsx)(frontend_button_1.Button, {
          fullwidth: true,
          onClick: onClickAddToCart,
          disabled: quantity === 0 || typeof quantity === "undefined" || isDebouncing || hasError || leadTimeDays === undefined,
          size: "sm",
          label: SearchResultItemContent_1.SearchResultItemContent[language].addToCart,
          paddingType: "relaxed"
        })
      })]
    })]
  });
};

exports.default = SearchResultItemDesktop;